import http from '@/utils/http';
const base_path = '/v2/tool/channelPackage';

/**
 * 获取渠道包列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getChannelPackageApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 同步渠道包接口
 * @param {Object} params 请求参数
 * @returns {Promise<Object>}
 */
export const pullChannelPackageApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};

/**
 * 获取未匹配到渠道包的渠道号接口
 * @param {Object} params 请求参数
 * @returns {Promise<Object>}
 */
export const getUnmatchedChannelAliasesApi = (params) => {
  return http.get({
    url: `${base_path}/getUnmatchedChannelAliases`,
    params,
  });
};
